import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../../components/ui/button';
import { ClipboardList, FileSpreadsheet, MessageSquare, LogOut } from 'lucide-react';
import { NotificationBell } from '../../components/NotificationBell';

export const LabShell = ({ children, title }) => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const nav = [
    { href: '/lab/orders', icon: ClipboardList, label: 'Dossiers' },
    { href: '/lab/invoices', icon: FileSpreadsheet, label: 'Factures' },
    { href: '/lab', icon: MessageSquare, label: 'Messagerie', exact: true },
  ];
  return (
    <div className="min-h-screen bg-secondary/30" data-testid="lab-shell">
      <header className="h-14 border-b border-border bg-background flex items-center justify-between px-3 sm:px-6 sticky top-0 z-40">
        <div className="flex items-center gap-3 min-w-0">
          <img src="https://customer-assets.emergentagent.com/job_dental-chat-5/artifacts/vbzuvp2d_1000265186.jpg" alt="JC" className="w-8 h-8 object-contain" />
          <div className="min-w-0 hidden sm:block">
            <h1 className="font-bold text-sm truncate">Jeff Connect — Laboratoire</h1>
            <p className="text-xs text-muted-foreground truncate">{user?.name}</p>
          </div>
        </div>
        <nav className="flex items-center gap-1">
          {nav.map(({ href, icon: Icon, label, exact }) => {
            const active = exact ? location.pathname === href : location.pathname.startsWith(href);
            return (
              <Link key={href} to={href}>
                <Button variant={active ? 'secondary' : 'ghost'} size="sm" className="gap-2" data-testid={`lab-nav-${label.toLowerCase()}`}>
                  <Icon className="h-4 w-4" /><span className="hidden sm:inline">{label}</span>
                </Button>
              </Link>
            );
          })}
          <NotificationBell />
          <Button variant="ghost" size="icon" onClick={logout} title="Déconnexion" data-testid="lab-logout-btn">
            <LogOut className="h-4 w-4" />
          </Button>
        </nav>
      </header>
      <main className="max-w-5xl mx-auto p-4 sm:p-6">
        {title && <h2 className="text-xl font-bold tracking-tight mb-4">{title}</h2>}
        {children}
      </main>
    </div>
  );
};

export default LabShell;
